<template>
  <div class="heatmap_grid"
       v-if="ready">
    <template v-for="[left, column] of Object.entries(this.gridData[this.heatmapType])">
      <div class="grid-cell"
           v-for="[top, value] of Object.entries(column)"
           :key="`grid-${top}-${left}`"
           :style="{ top: top * scale + 'px', left: left * scale + 'px' }">
        <i class="icon"
           :style="{ transform: `scale(${containerScale * getPercent(value)})`, opacity: getPercent(value) }"
           :class="`cell-${iconType}-5`"></i>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'HeatmapGrid',
  props: [
    'gridData',
    'heatmapType',
    'device',
    'eventType',
    'scale',
    'containerScale'
  ],
  computed: {
    iconType () {
      if (this.eventType === 'zoom') {
        return ['zoom-in', 'zoom-out'][this.heatmapType]
      } else {
        return 'double-tap'
      }
    }
  },
  watch: {
    scale (value) {
      this.clearHeatmap()
      this.loadHeatmap()
    }
  },
  mounted () {
    if (!this.isLoadedOnce) {
      this.loadHeatmap()
    }
  },
  destroyed () {
    this.clearHeatmap()
  },
  methods: {
    clearHeatmap () {
      this.minVal = Infinity
      this.maxVal = 0
      this.ready = false
    },
    loadHeatmap () {
      this.ready = false
      this.isLoadedOnce = true
      for (const column of Object.values(this.gridData[this.heatmapType])) {
        for (const value of Object.values(column)) {
          this.minVal = Math.min(this.minVal, value)
          this.maxVal = Math.max(this.maxVal, value)
        }
      }
      this.ready = true
    },
    getWeight (value) {
      if (this.maxVal === value) {
        return this.step
      }
      const range = this.maxVal - this.minVal
      const compare = value - this.minVal
      return Math.floor((compare / range) * this.step) + 1
    },
    getPercent (value) {
      if (this.maxVal === value) {
        return 1
      }
      const range = this.maxVal - this.minVal
      const compare = value - this.minVal
      return compare / range
    }
  },
  data () {
    return {
      isLoadedOnce: false,
      minVal: Infinity,
      maxVal: 0,
      ready: false,
      step: 5
    }
  }
}
</script>

<style lang="scss">
.heatmap_grid {
  height: 100%;
  position: absolute;
  top: 0;

  .grid-cell {
    position: absolute;
    transform: translate(-50%, -50%);

    .icon {
      width: 56px;
      height: 56px;
      background-position: center center;
      background-size: auto auto;
      background-repeat: no-repeat;

      &.cell-double-tap-1 {
        background-image: url(../../assets/img/grid-cell-double-tap-1.svg);
      }

      &.cell-double-tap-2 {
        background-image: url(../../assets/img/grid-cell-double-tap-2.svg);
      }

      &.cell-double-tap-3 {
        background-image: url(../../assets/img/grid-cell-double-tap-3.svg);
      }

      &.cell-double-tap-4 {
        background-image: url(../../assets/img/grid-cell-double-tap-4.svg);
      }

      &.cell-double-tap-5 {
        background-image: url(../../assets/img/grid-cell-double-tap-5.svg);
      }

      &.cell-zoom-in-1 {
        background-image: url(../../assets/img/grid-cell-zoom-in-1.svg);
      }

      &.cell-zoom-in-2 {
        background-image: url(../../assets/img/grid-cell-zoom-in-2.svg);
      }

      &.cell-zoom-in-3 {
        background-image: url(../../assets/img/grid-cell-zoom-in-3.svg);
      }

      &.cell-zoom-in-4 {
        background-image: url(../../assets/img/grid-cell-zoom-in-4.svg);
      }

      &.cell-zoom-in-5 {
        background-image: url(../../assets/img/grid-cell-zoom-in-5.svg);
      }

      &.cell-zoom-out-1 {
        background-image: url(../../assets/img/grid-cell-zoom-out-1.svg);
      }

      &.cell-zoom-out-2 {
        background-image: url(../../assets/img/grid-cell-zoom-out-2.svg);
      }

      &.cell-zoom-out-3 {
        background-image: url(../../assets/img/grid-cell-zoom-out-3.svg);
      }

      &.cell-zoom-out-4 {
        background-image: url(../../assets/img/grid-cell-zoom-out-4.svg);
      }

      &.cell-zoom-out-5 {
        background-image: url(../../assets/img/grid-cell-zoom-out-5.svg);
      }
    }
  }
}
</style>
